
import { mapGetters } from 'vuex';
import hasConversationPermissions from '@/mixins/hasConversationPermissions';

export default {
  name: 'ModalInboxItem',

  mixins: [hasConversationPermissions],

  props: {
    conversation: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      conversations: [],
    };
  },

  computed: {
    ...mapGetters('user', ['isClient', 'isEmployee']),

    canOpen() {
      return this.canViewConversation(this.conversation);
    },

    cannotOpenReason() {
      return this.canOpen ? '' : 'Your permissions only let you open conversations you take part in.';
    },
  },

  methods: {
    openConversation() {
      if (!this.canOpen) {
        return;
      }

      this.$nuxt.$emit('viewConvo', this.conversation);
    },
  },
};
